export default "__VITE_ASSET__DVQDLHdw__"